import { Avatar, Box, Typography, IconButton } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const MotionTypography = motion(Typography);

const Teams = [
  {
    name: "Mahendra Vyas",
    designation: "Founder",
    body: "I've never seen anything like this before. It's amazing. I love it.",
    img: "https://avatar.vercel.sh/jack",
    links: {
      facebook: "https://www.facebook.com/mahen.vyas.94",
      instagram: "https://www.instagram.com/mahender_vyas/",
      linkedin: "https://linkedin.com",
    },
  },
  {
    name: "Mukesh Raj Vyas",
    designation: "Co-Founder",
    body: "I've never seen anything like this before. It's amazing. I love it.",
    img: "https://avatar.vercel.sh/jack",
    links: {
      facebook: "https://www.facebook.com/mukesh.r.vyas",
      instagram: "https://www.instagram.com/mraj.bkn/",
      linkedin: "https://www.linkedin.com/in/mukeshh-raj-vyas-09000b14/",
    },
  },
];

function OurTeam() {
  return (
    <Box sx={{ p: 4, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
      <Box sx={{ gap: "1rem" }}>
        <MotionTypography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#333",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          Our Leadership Team
        </MotionTypography>
        <MotionTypography sx={{ textAlign: "center", marginBottom: "1.5rem" }}>
          We are a dedicated team of educators, committed to delivering
          top-notch learning experiences to empower our students.
        </MotionTypography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: {
            xs: "flex-start",
            sm: "center",
          },
          flexDirection: { xs: "row", sm: "row" },
          // gap: "1rem",
          overflowX: "auto",
          // width: "100%",
        }}
      >
        {Teams.map((teamMember, index) => (
          <Box
            key={index}
            sx={{
              backgroundColor: "white",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              borderRadius: "16px",
              p: 3,
              m: 2,
              minWidth: { xs: "300px" },
              maxWidth: { xs: "300px" },
              textAlign: "center",
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <Avatar
              alt={teamMember.name}
              src={teamMember.img}
              sx={{
                width: 100,
                height: 100,
                margin: "0 auto",
                mb: 2,
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
              }}
            />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {teamMember.name}
            </Typography>
            <Typography variant="body1" sx={{ color: "#777" }}>
              {teamMember.designation}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              {teamMember.body}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              {teamMember.links.facebook && (
                <IconButton
                  component="a"
                  href={teamMember.links.facebook}
                  target="_blank"
                  sx={{ color: "black !important" }}
                >
                  <FaFacebook />
                </IconButton>
              )}
              {teamMember.links.instagram && (
                <IconButton
                  component="a"
                  href={teamMember.links.instagram}
                  target="_blank"
                  sx={{ color: "black !important" }}
                >
                  <FaInstagram />
                </IconButton>
              )}
              {teamMember.links.linkedin && (
                <IconButton
                  component="a"
                  href={teamMember.links.linkedin}
                  target="_blank"
                  sx={{ color: "black !important" }}
                >
                  <FaLinkedin />
                </IconButton>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default OurTeam;
